// extracted by mini-css-extract-plugin
export default {"ToolBox":"ToolBox_ToolBox__B2QCv","border":"ToolBox_border__U7ChC","Upload":"ToolBox_Upload__-DkmU"};